import { useEffect } from "react";

/** Warn on tab close / refresh when a form has unsaved edits. */
export function useDirtyFormGuard(isDirty: boolean, message = "You have unsaved changes.") {
  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty, message]);
}

export function confirmDiscardDirty(isDirty: boolean, message?: string): boolean {
  if (!isDirty) return true;
  return window.confirm(message ?? "Discard unsaved changes?");
}

export function paginateList<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function pageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export type PageSizeOption = 5 | 10 | 20;

export const DEFAULT_PAGE_SIZE: PageSizeOption = 5;
